import { render, staticRenderFns } from "./data-table.vue?vue&type=template&id=1ad0217d"
import script from "./data-table.vue?vue&type=script&lang=js"
export * from "./data-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports